<template>
  <div class="IdentitySelectDialog">
    <van-popup v-model="showDialog" :close-on-click-overlay="false">
      <div class="content">
        <div class="header">
          <img src="../../../assets/images/attestation/identity-backimg.png" alt="" srcset="">
        </div>
        <div class="bottom">
          <p>请选择您的身份，以便为您提供更好服务! <br/>选择后立即开始查询</p>
          <div class="btn" @click="defineBtn">确定</div>
        </div>
        <div class="close-icon" @click="showDialog=false">
          <img src="../../../assets/images/attestation/icon-close.png" alt="" srcset="">
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { wxNavigateTo } from '../../../utils/WeChatUtil'
export default {
  props: {},
  data() {
    return {
      showDialog: false,
    };
  },
  methods: {
    /**
     *
     * 显示弹框
    */
    showPopup() {
      this.showDialog = true
    },
    /**
     *
     *
     * 确定事件
    */
    defineBtn() {
      this.showDialog = false
      if (this.isWechart) {
        wxNavigateTo('/pages/user/attestation/identity-select/index')
      }
    }
  }
};
</script>

<style scoped lang="scss">
.IdentitySelectDialog>:first-child {
  background-color: rgba(0,0,0,.4)
}
.IdentitySelectDialog>:nth-child(2){
  width: 80%;
  top: 40%;
  border-radius: 18px;
  background-color: transparent;
}
.IdentitySelectDialog {
  .content {
    position: relative;
    .header {
      height: 362px;
      img {
        width: 100%;
      }
    }
    .bottom {
      padding-top: 50px;
      padding-bottom: 20px;
      background-color: #ffffff;
      p {
        color: #808080;
        font-size: 26px;
        text-align: center;
        line-height: 50px;
      }
      .btn {
        background-image: url('../../../assets/images/attestation/inentity-btnimg.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        margin: 10px auto;
        height: 80px;
        color: #ffffff;
        font-size: 32px;
        text-align: center;
        line-height: 80px;
        margin: 40px 100px;
      }
    }
    .close-icon {
      position: absolute;
      right: 30px;
      top: 30px;
      img {
        width: 30px;
      }
    }
  }
}
</style>
